"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handle401status = void 0;
var _ = require("./");
var handle401status = function handle401status() {
  sessionStorage.removeItem('user');
  window.location.href = (0, _.getSignInUrl)();
};
exports.handle401status = handle401status;